import { render } from "./News.vue?vue&type=template&id=243e1230&scoped=true"
const script = {}

import "./News.vue?vue&type=style&index=0&id=243e1230&scoped=true&lang=css"

import exportComponent from "/home/appiah/Documents/projects/greenfield/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-243e1230"]])

export default __exports__